import React, { forwardRef } from 'react'
import MenuItem from '@mui/material/MenuItem'

function CustomMenuItem (props) {
  return (
    <MenuItem
      {...props}
      classes={{ root: 'list-menu-item', selected: 'selected_item' }}
      className={props.className}
      style={{ display: 'block', padding:"5px 15px" }}
    />
  )
}

export default forwardRef(CustomMenuItem)
